import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useT } from "src/i18n";

export default function OfferProgressIndicator({ currentStep }) {
    const theme = useTheme();
    const t = useT();
    const w = theme.custom?.wizard ?? {};
    const STEPS = [
        { id: 1, title: t("valut.progress.step1Title"), sub: t("valut.progress.step1Sub") },
        { id: 2, title: t("valut.progress.step2Title"), sub: t("valut.progress.step2Sub") },
        { id: 3, title: t("valut.progress.step3Title"), sub: t("valut.progress.step3Sub") },
    ];
    return (
        <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={{ xs: 1.5, md: 2 }}
            sx={{ alignItems: "stretch", mb: 3 }}
        >
            {STEPS.map((step) => {
                const isActive = step.id === currentStep;
                const isPast = step.id < currentStep;
                const accent = w.amber || theme.palette.warning.main;
                return (
                    <Box
                        key={step.id}
                        sx={{
                            flex: 1,
                            p: 2,
                            borderRadius: w.microRadius ? `${w.microRadius}px` : "14px",
                            background: w.microBg || "rgba(36,56,66,0.65)",
                            backdropFilter: w.microBlur || "blur(16px) saturate(140%)",
                            WebkitBackdropFilter: w.microBlur || "blur(16px) saturate(140%)",
                            border: isActive ? `1px solid ${accent}` : (w.cardBorder ?? "1px solid rgba(244,242,238,0.08)"),
                            opacity: isPast ? 0.7 : 1,
                        }}
                    >
                        <Typography variant="caption" sx={{ color: accent, fontWeight: 700 }}>
                            {step.id}.
                        </Typography>{" "}
                        <Typography component="span" variant="subtitle2" sx={{ ml: 0.5 }}>
                            {step.title}
                        </Typography>
                        <Typography variant="caption" sx={{ color: "text.secondary", display: "block", mt: 0.5 }}>
                            {step.sub}
                        </Typography>
                    </Box>
                );
            })}
        </Stack>
    );
}
